import { jsx, Fragment } from "react/jsx-runtime";
import { memo, useEffect } from "react";
import { Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import "../../../../entities/vehicle/api/api.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../entities/vehicle/model/selectors/selectVehicleParameters.js";
import "react-redux";
import "../../../../features/benefitChoice/model/index.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "@perxis-auto/shared";
import "../../../../shared/store/config/middleware/index.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import { useGetVehicles } from "../../../../entities/vehicle/lib/useGetVehicles.js";
import "../../../../entities/vehicle/model/selectors/selectIsVehiclesDataMissing.js";
import "../../../../entities/vehicle/model/selectors/selectVehicle.js";
import "../../../../entities/vehicle/model/selectors/selectVehicles.js";
import "../../../../entities/vehicle/model/selectors/selectVehiclesCount.js";
import "../../../../entities/vehicle/model/selectors/selectVehiclesParameters.js";
import "../../../../entities/vehicle/model/selectors/selectVehiclesTotalPages.js";
import "../../../../features/filterValues/api/api.js";
import "../../../../features/filterValues/model/middleware/index.js";
import "../../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import { APP } from "../../../../shared/config/app.js";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "react-router";
import "../../../../shared/store/installation/model/slice.js";
import { selectSlice } from "../../../../shared/store/pagination/model/selectors/selectSlice.js";
import "../../../../shared/store/pagination/model/slice.js";
import "../../../../features/filterChoice/model/middleware/index.js";
import "../../../../features/filterChoice/model/selectors/selectFilterHistory.js";
import "../../../../features/filterChoice/model/selectors/selectFilterSortValue.js";
import "../../../../features/filterChoice/model/selectors/selectFilterValuesCount.js";
import { selectIsFilterPanelVisible } from "../../../../features/filterChoice/model/selectors/selectIsFilterPanelVisible.js";
import "../../../../features/filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../../features/filterChoice/model/selectors/selectSlugedFilterValues.js";
import "../../../../features/filterChoice/model/slice.js";
import "../../../../shared/context/constructor.js";
import { LoadingContext, ThisProvider } from "../../../../shared/context/this.js";
import { Constructor } from "../../../../shared/ui/constructor/Constructor.js";
import { Link } from "../../../../shared/ui/link/Link.js";
const Page = memo(function Page2({ page, redirect, layout, widgets, onLoadedVehicles }) {
  const showFilters = useAppSelector(selectIsFilterPanelVisible);
  const { limit } = useAppSelector(selectSlice);
  const offset = page * limit;
  const {
    data,
    isLoading: isLoadingQuery,
    isUninitialized: isUninitializedQuery
  } = useGetVehicles({
    offset
  });
  const vehicles = data == null ? void 0 : data.items;
  const isHidden = !vehicles;
  const isLoading = isLoadingQuery || isUninitializedQuery;
  useEffect(() => {
    if (isHidden) {
      return;
    }
    onLoadedVehicles();
  }, [isHidden]);
  if (isLoading) {
    return /* @__PURE__ */ jsx(LoadingContext.Provider, { value: isLoading, children: Array.from(Array(limit)).map((_, index) => /* @__PURE__ */ jsx(
      Col,
      {
        xs: 24,
        sm: showFilters ? 24 : 12,
        md: showFilters ? 24 : 12,
        lg: showFilters ? 12 : 8,
        xl: showFilters ? 8 : 6,
        xxl: 6,
        children: /* @__PURE__ */ jsx(Constructor, { isSubConstructor: true, layout, widgets })
      },
      `${String(index)}`
    )) });
  }
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ jsx(Fragment, { children: vehicles.map((vehicle) => {
    var _a;
    return /* @__PURE__ */ jsx(
      Col,
      {
        xs: 24,
        sm: showFilters ? 24 : 12,
        md: showFilters ? 24 : 12,
        lg: showFilters ? 12 : 8,
        xl: showFilters ? 8 : 6,
        xxl: 6,
        children: /* @__PURE__ */ jsx(ThisProvider, { data: vehicle, isLoading, children: /* @__PURE__ */ jsx(
          Link,
          {
            onClick: () => sessionStorage.setItem(`${APP.name}/scroll`, `${document.documentElement.scrollTop}`),
            ...redirect.options,
            to: redirect.to,
            params: {
              ...(_a = redirect.options) == null ? void 0 : _a.params,
              vehicleId: vehicle.id
            },
            children: /* @__PURE__ */ jsx(Constructor, { isSubConstructor: true, layout, widgets })
          }
        ) }, vehicle.id)
      },
      vehicle.id
    );
  }) });
});
export {
  Page
};
